import { ProcessType } from "@scts/models";

export const ProcessOpen = ({ processType }: { processType: ProcessType | undefined }) => {
  return (
    <>
      {processType === "Appeal" && (
        <span className=" d-none d-sm-block">Show appeal process </span>
      )}
      {processType === "Complaint" && (
        <span className=" d-none d-sm-block">Show complaint process </span>
      )}
      <span className=" d-block d-sm-none">Show process </span>
      <i className="bi bi-chevron-down"></i>
    </>
  );
};

export default ProcessOpen;

